import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api_request, downloadExcel } from "../../store/actions/commonAction";
import { API_METHOD_GET, API_METHOD_POST } from "../../config/constants";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Icon,
  IconButton,
  MenuItem,
} from "@mui/material";
import {
  FETCH_DOC_USERS_ERROR,
  FETCH_DOC_USERS_SUCCESS,
  GROUP_DATA_ERROR,
  GROUP_DATA_SUCCESS,
} from "../../store/types/billTypes";
import { useLocation } from "react-router";
import CoreH6 from "../../core/dataDisplay/CoreH6";
import { setBillReducer } from "../../store/actions/billActions";
import "./comp.style.css";
import CoreH5 from "../../core/dataDisplay/CoreH5";
import { theme } from "../../config/theme";
import CoreH3 from "../../core/dataDisplay/CoreH3";
import CoreInput from "../../core/inputs/CoreInput";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import CoreModal from "../../core/layouts/CoreModal";
import CoreDatePicker from "../../core/inputs/CoreDatePicker";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import CoreSelect from "../../core/inputs/CoreSelect";

export default function ComparatorDashboard() {
  const users = useSelector((state) => state.bill.userDocs);
  const user = useSelector((state) => state.auth.user);
  const groupDocsSuccess = useSelector((state) => state.bill.groupDocsSuccess);
  const groupDocsError = useSelector((state) => state.bill.groupDocsError);
  const tools = useSelector((state) => state.common.tools);
  const projects = useSelector((state) => state.common.projectsLatest);
  const location = useLocation();

  const tool = location.pathname.split("/")[1];
  const toolMeta = tools?.find((t) => t.name === tool)?.extraInfo?.dashboard;
  const userSettings = useSelector((state) => state?.common?.userSettings);

  const [dashboardData, setDasboardData] = useState(null);
  const [minQuatation, setMinQuatation] = useState(null);
  const [project, setProject] = useState(null);
  const [exportModal, setExportModal] = useState(false);
  const [startDate, setStartDate] = useState(false);
  const [endDate, setEndDate] = useState(false);
  const [onlyProject, setOnlyProject] = useState(false);
  const directDownload = userSettings?.find(
    (set) => set.name === "comparator-direct-download",
  )
    ? userSettings?.find((set) => set.name === "comparator-direct-download")
        ?.value?.enabled
    : true;

  const dispatch = useDispatch();

  useEffect(() => {
    getData();
    dispatch(
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
    );
  }, []);

  useEffect(() => {
    if (groupDocsSuccess) {
      getData();
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false });
    }
    if (groupDocsError) {
      alert("Internal error");
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false });
    }
  }, [groupDocsSuccess, groupDocsError]);

  const getMinQuotation = (data) => {
    let min = Number.MAX_VALUE;
    let minText = "";
    for (let i = 0; i < data?.length; i++) {
      if (data[i].Quotation) {
        let quotation = data[i].Quotation.replaceAll(
          /[a-zA-Z,-/]*/g,
          "",
        ).trim();
        console.log("quotation ", quotation);
        if (Number(quotation) < min) {
          min = Number(quotation);
          minText = data[i].Quotation;
        }
      } else if (data[i]["Net PREMIUM"]) {
        let quotation = data[i]["Net PREMIUM"]
          .replaceAll(/[a-zA-Z,-/]*/g, "")
          .trim();
        console.log("quotation ", quotation);
        if (Number(quotation) < min) {
          min = Number(quotation);
          minText = data[i]["Net PREMIUM"];
        }
      }
    }
    return min === Number.MAX_VALUE ? null : { value: min, label: minText };
  };

  useEffect(() => {
    if (users && users.length > 0 && project) {
      let doc = users?.find((doc) => doc?.info?.data?.projectId === project);
      console.log(users, project, doc);
      let docs = doc?.info?.criteria;
      let tempFinal = [];
      let finalData = [];
      let parts = [];
      console.log("docs ", docs);
      if (docs && docs[0] && docs[0][0]?.label) {
        for (let i = 0; i < docs?.length; i++) {
          let ob = {};
          for (let j = 0; j < docs[i]?.length; j++) {
            if (!parts.includes(docs[i][j].label)) {
              parts.push(docs[i][j].label);
            }
            if (docs[i][j]?.value?.includes("[")) {
              let temp = docs[i][j]?.value
                ?.replaceAll("[", "")
                .replaceAll("]", "");
              ob[docs[i][j].label] = temp;
            } else {
              ob[docs[i][j].label] = docs[i][j].value;
            }
          }
          tempFinal.push(ob);
        }
      } else {
        tempFinal = docs;
        parts = docs
          ? Object.keys(docs[0]).filter(
              (key) =>
                key !== "Company Name" &&
                key !== "part_type" &&
                key !== "File Name" &&
                key !== "Sl No",
            )
          : [];
      }
      let minQuatation = getMinQuotation(tempFinal);
      setMinQuatation(minQuatation);
      console.log("parts ", parts, minQuatation);
      for (let i = 0; i < parts?.length; i++) {
        let ob = { Parameter: parts[i] };
        for (let j = 0; j < tempFinal?.length; j++) {
          ob[tempFinal[j]["Company Name"]] = tempFinal[j][parts[i]];
        }
        finalData.push(ob);
      }
      setDasboardData(finalData);
    }
  }, [users, project]);

  const getData = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/all/DocGroups",
        {},
        {
          _defaultFilter: encodeURIComponent(
            JSON.stringify({ userId: user.id, tool, type: "basic" }),
          ),
        },
        null,
        FETCH_DOC_USERS_SUCCESS,
        FETCH_DOC_USERS_ERROR,
        true,
        false,
      ),
    );
  };

  const groupData = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/group/documents",
        {},
        {},
        null,
        GROUP_DATA_SUCCESS,
        GROUP_DATA_ERROR,
        true,
        false,
      ),
    );
  };

  const exportData = (data) => {
    dispatch(
      downloadExcel(
        {},
        "/comparator/export",
        API_METHOD_POST,
        data && Array.isArray(data) && directDownload
          ? { data: data }
          : onlyProject
            ? { projectId: project }
            : { startDate, endDate },
      ),
    );
  };

  console.log("cols ", tools, toolMeta, dashboardData, project);

  return (
    <div
      style={{
        height: "calc(100vh - 68px - 4px)",
        width: "calc(100% + 32px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: "-8px",
        marginTop: "-8px",
      }}
    >
      <CoreModal
        title="Download"
        open={exportModal}
        handleClose={() => {
          setExportModal(false);
        }}
      >
        <Box style={{ marginTop: 16 }}>
          <CoreDatePicker
            disabled={onlyProject}
            value={startDate}
            onChange={(val) => setStartDate(val)}
            label="Start Date"
          />
        </Box>
        <Box style={{ marginTop: 16 }}>
          <CoreDatePicker
            disabled={onlyProject}
            value={endDate}
            onChange={(val) => setEndDate(val)}
            label="End Date"
          />
        </Box>
        <CoreTypographyBody1>Or,</CoreTypographyBody1>
        {
          <FormControlLabel
            control={
              <Checkbox
                checked={onlyProject}
                onChange={() => {
                  setOnlyProject(!onlyProject);
                }}
              />
            }
            label="Only this project"
          />
        }
        <CoreButtonContainer>
          <CoreContainedButton onClick={exportData}>Submit</CoreContainedButton>
        </CoreButtonContainer>
      </CoreModal>
      <Box style={{ padding: 16, height: "100%", width: "100%" }}>
        {project ? (
          <Box>
            <Box
              style={{
                display: "flex",
                height: "100%",
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid black",
              }}
            >
              <CoreH3
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 16,
                }}
              >
                Smart Compare
                <IconButton onClick={groupData}>
                  <Icon style={{ marginLeft: 16 }} color="primary">
                    monitor
                  </Icon>
                </IconButton>
              </CoreH3>

              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 16,
                  height: "100%",
                  minWidth: "30%",
                  marginBottom: 16,
                }}
              >
                {project && projects && (
                  <CoreSelect
                    label={"Select Project"}
                    value={project}
                    handleChange={(e) => {
                      console.log("selected project ", e.target.value);
                      setProject(e.target.value);
                    }}
                    options={projects}
                  />
                )}
                <CoreIconButton
                  onClick={
                    directDownload
                      ? () => {
                          exportData(dashboardData);
                        }
                      : () => {
                          setExportModal(true);
                        }
                  }
                >
                  <Icon>download</Icon>
                </CoreIconButton>
              </Box>
            </Box>

            <CoreDataTable
              id="documentList"
              actions={[]}
              rowActions={[]}
              columns={
                dashboardData && dashboardData[0]
                  ? Object.keys(dashboardData[0]).map((key) => {
                      return {
                        label: key,
                        value: key,
                        view: (row) => {
                          return row[key] === "Yes" ||
                            (minQuatation &&
                              row[key] === minQuatation.label) ? (
                            <Box
                              style={{
                                minHeight: "100%",
                                minWidth: "100%",
                                padding: 8,
                                backgroundColor: theme.palette.success.light,
                              }}
                            >
                              {row[key]}
                            </Box>
                          ) : (
                            row[key]
                          );
                        },
                      };
                    })
                  : []
              }
              dataRows={dashboardData || []}
              searchable={false}
              selectable={false}
              pagination={false}
              toolBar={false}
            />
          </Box>
        ) : (
          <Box
            style={{
              display: "flex",
              height: "100%",
              width: "100%",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Card style={{ minWidth: "70vw" }}>
              <CardContent>
                <Box
                  style={{
                    display: "flex",
                    height: "100%",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                  }}
                >
                  <Box style={{ textAlign: "center" }}>
                    <CoreH5 color="primary">Select a project to compare</CoreH5>
                    <CoreIconButton onClick={groupData}>
                      <Icon>refresh</Icon>
                    </CoreIconButton>
                  </Box>
                  <Box>
                    <CoreInput
                      label="Select Project"
                      endAdornment={<Icon>search</Icon>}
                    />
                    <Box
                      style={{
                        maxHeight: 300,
                        minHeight: 300,
                        overflowY: "auto",
                      }}
                    >
                      {projects.map((row) => (
                        <MenuItem
                          onClick={() => {
                            setProject(row.id);
                          }}
                        >
                          {row.name}
                        </MenuItem>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>
        )}
      </Box>
    </div>
  );
}
